module.exports = __webpack_public_path__ + "img/axismedical-logo.ebca3dd8.png";